<div class="marquee-wrapper" *ngIf="items.length > 0" [ngClass]="{'cursor-pointer': !isToken}" (click)="routeToToken()">
  <div class="marquee-container top-bar">
    <div class="marquee">
      <div class="content d-flex align-items-center">
        <div class="d-flex align-items-center" *ngFor="let item of items">
          <p class="font-16 font-sm-12 text-black m-0 mx-2">
            {{ item | translate : {remainingDays} }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>